import { createFileRoute } from '@tanstack/react-router'

import { BeneficiariesPageSkeleton } from '#/modules/health/front-office/beneficiaries-page/beneficiaries-page-skeleton.tsx'
import { BeneficiariesPage } from '#/modules/health/front-office/beneficiaries-page/beneficiaries-page.tsx'
import { FRONT_OFFICE_V2_QUERY_OPTIONS } from '#/shared/front-office-v2-query-options.ts'

export const Route = createFileRoute('/(customer)/_shell/health-insurance-v2/beneficiaries')({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      context.trpc.muta.getMutaBeneficiariesInfos.queryOptions(undefined, FRONT_OFFICE_V2_QUERY_OPTIONS),
    ),
  pendingComponent: BeneficiariesPageSkeleton,
  pendingMs: 150,
  component: BeneficiariesPage,
})
